/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateShareLinkRequest } from '../../models/create-share-link-request';
import { ShareLinkDto } from '../../models/share-link-dto';

export interface SharingLinksPost$Json$Params {
      body?: CreateShareLinkRequest
}

export function sharingLinksPost$Json(http: HttpClient, rootUrl: string, params?: SharingLinksPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ShareLinkDto>> {
  const rb = new RequestBuilder(rootUrl, sharingLinksPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShareLinkDto>;
    })
  );
}

sharingLinksPost$Json.PATH = '/sharing/links';
